export default __webpack_public_path__ + "static/media/gutex_logo_dark.5e5b0cef.png";